/** Get Dashboard Chart data */
export const API_SUCCESS = "API_SUCCESS";
export const API_FAIL = "API_FAIL";
export const GET_CHARTS_DATA = "GET_CHARTS_DATA";

export const GET_COUNTS_ON_DASHBOARD = "GET_COUNTS_ON_DASHBOARD"
export const GET_COUNTS_ON_DASHBOARD_SUCCESS = "GET_COUNTS_ON_DASHBOARD_SUCCESS"
export const GET_COUNTS_ON_DASHBOARD_FAILED = "GET_COUNTS_ON_DASHBOARD_FAILED"